import styled from 'styled-components';
import { Typography } from 'antd';

export const StyledText = styled(Typography.Text)`
  ${(props) => `
        color: ${props.theme.widgets.color.full};
  `}
`;
